import React, {FunctionComponent} from 'react';
import classnames from 'classnames';
import {Checkbox, Button, Row, Col, Tag, Popconfirm, message, Icon as AIcon, Popover} from 'antd';
import {Icon} from '@/components';
import StylesType from '@/types/StylesType';
import copy from 'copy-to-clipboard';
import './style';


export interface DeviceContainerProps extends StylesType {
  onChange: (e: any) => void;
  options: optionsType,
  checked: boolean
};

export interface optionsType {
  deviceName: string,
  cid: string,
  deviceImg: string,
  deviceHomePageVasList: any[],
}

/* 头部 */
export const DeviceHead: React.FC<DeviceContainerProps> = props => {
  const {onChange, prefixCls = 'gc-device-container', options, checked} = props;
  
  const handleCheckbox = (e: any) => {
    onChange({type: 'checkbox', key: e.target.checked, value: options.cid })
  }
  
  const handleIcon = (e: any, key: string) => {
    e.persist();
    onChange({type: 'icon',key,value: options.cid})
  }
  
  const handleConfirm = () => {
    copy(options.cid)
    message.success('复制成功！');
  }
  
  return (
    <div className={classnames(`${prefixCls}-head`)}>
      
      <Checkbox onChange={handleCheckbox} checked={checked}>{options.deviceName || options.cid}</Checkbox>
      <Row type='flex' gutter={16}>
        <Col>
          <Icon onClick={(e) => handleIcon(e,'edit')} type='iconEdit' />
        </Col>
        <Col>
          <Popconfirm
            icon={null}
            placement="topLeft"
            title={`当前云机设备号：${options.cid}`}
            okText="复制"
            cancelText="取消"
            onConfirm={handleConfirm}
          >
           <Icon type='iconfind'/>
          </Popconfirm>
          </Col>
      </Row>
    </div>
  )
};

/* 操作按钮 */
export const DeviceAction: React.FC<DeviceContainerProps> = props => {
  
  const {prefixCls = 'gc-device-container', onChange, options} = props;
  const buttonName = classnames(`${prefixCls}-action-button`);
  
  const handleButton = (e: any) => {
    e.persist();
    e.stopPropagation();
    const key = e.target.getAttribute('data-key')
    onChange({type: 'button',key,value: options.cid })
  }
  
  return (
    <div className={classnames(`${prefixCls}-action`)}>
      <Button onClick={handleButton} className={buttonName} data-key='1' >重启云机</Button>
      <Button onClick={handleButton} className={buttonName} data-key='2'>回收云机</Button>
      <Button onClick={handleButton} className={buttonName} data-key='3'>停止应用</Button>
      <Button onClick={handleButton} className={buttonName} data-key='4'>故障维修</Button>
    </div>
  )
};

/* 屏幕 */
export const DeviceScreen: React.FC<DeviceContainerProps> = props => {
  
  const {prefixCls, options, onChange} = props;
  
  const handleImgOnError = (e: React.SyntheticEvent<Element, Event>) => {
    e.persist();
    // @ts-ignore
    e.target.src = require('./icon.jpg')
  }
  
  const handleScreen = () => {
    onChange({type: 'screen',value: options.cid })
  }
  
  return (
    <div onClick={handleScreen} className={classnames(`${prefixCls}-screen`)}>
      <Loading  {...props} />
  
      <img onError={handleImgOnError} className={classnames(`${prefixCls}-screen-img`)} src={options.deviceImg || require('./icon.jpg')}
           alt={options.deviceName}/>
      <DeviceAction {...props}/>
    </div>
  )
};

/* 底部标签 */
export const DeviceFooter: React.FC<DeviceContainerProps> = props => {
  
  const {prefixCls, options} = props;
  
  const {deviceHomePageVasList} = options;
  
  return (
    <Row type='flex' align='middle' className={`${prefixCls}-footer`}>
      {deviceHomePageVasList.map((vasData) => {
        if ( vasData.productId === 21) {
          return	<Col key={vasData.productId} span={6}><Tag color="#21D8B1">新机</Tag></Col>
        }
        if (vasData.productId === 31) {
          return <Col key={vasData.productId}>
            {
              vasData.outerNetIp ?
                <Popover content={vasData.outerNetIp}>
                  <Tag color="#FC8056">IP({['','初','中','高'][vasData.productGradeId]})</Tag>
                </Popover>:
                <Tag color="#FC8056">IP({['','初','中','高'][vasData.productGradeId]})</Tag>
            }
            
          </Col>
        }
        return null
      })}
    </Row>
  )
  
}

export const Loading : FunctionComponent<DeviceContainerProps> = props => {
  
  const {prefixCls, options} = props;
  
  const text: any = {
    201: '启动',
    202: '停止',
    203: '更新应用',
    204: '更新应用',
    101: '申请',
    102: '续费',
    103: '重启',
    104: '恢复出厂',
    105: '回收',
    401: '一键新机',
    106: '设备修复',
    501: '开启ip',
    502: '关闭ip',
    503: '切换ip'
    
  }
  
  if ((options as any).phoneStatus !== 1) return <></>
  
  if (!((options as any).phoneOpType in text)) return <></>
  
  return (
    <div className={classnames(`${prefixCls}-screen-loading`)}>
      
      <AIcon type="loading" style={{marginRight: 10}} />
       正在{text[(options as any).phoneOpType]}中
    </div>
  )
}

/* 设备容器 */
export const DeviceContainer: FunctionComponent<DeviceContainerProps> = props => {
  
  const {className, style, prefixCls} = props;
  
  return (
    <div style={style} className={classnames(prefixCls, className)}>
      <DeviceHead {...props}/>
      <DeviceScreen {...props} />
      <DeviceFooter {...props} />
    </div>
  )
  
};

DeviceContainer.defaultProps = {
  prefixCls: 'gc-device-container',
  options: {
    deviceName: '',
    cid: '',
    deviceImg: require('./icon.jpg'),
    deviceHomePageVasList: [],
  }
};


export default DeviceContainer;
